/* Package JSON Import will be here */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    withRouter
} from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { ApiUrls } from '../../services/api';
import Api from '../../services/api/serviceCall';
import { Constants } from '../../config/appConstants';
import * as actions from '../../actions/login.Action';
import RegisterComponent from './register.Component';
import { MessageBox } from '../sharedComponent/messageBox';
import { osVersion, osName, isDesktop, isMobileOnly, isTablet, browserName, deviceType, mobileVendor, mobileModel, fullBrowserVersion } from 'react-device-detect';
import * as utility from '../../services/utility';
import packageJson from '../../../package.json';

class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDeviceAlreadyRegistered: this.props.device.isDeviceAlreadyRegistered ? this.props.device.isDeviceAlreadyRegistered : false,
            deviceId: this.props.device.deviceId ? this.props.device.deviceId : null,
            deviceUUID: this.props.device.deviceFingerPrintId ? this.props.device.deviceFingerPrintId : null,
            selectedDivisionName: '',
            selectedDivisionId: 0,
            fullName: '',
            deviceModelDD: [],
            deviceType: 'Web',
            currentDeviceName: '',
            divisionNumberDD: [],
            isShowLoader: false,
            employeeRegiterdDevices: [],
            selectedEmployeeDevice: "",
            employeeNumber: "",
            isShowRegisteredDeviceModel: false,
        }
    };

    componentWillMount() {
        let deviceName = "";
        if (isDesktop) {
            deviceName = `Desktop_${deviceType}_${osName}${osVersion}_${browserName}${fullBrowserVersion}`
        } else if (isMobileOnly) {
            deviceName = `Mobile_${mobileVendor}_${mobileModel}_${osName}${osVersion}_${browserName}${fullBrowserVersion}`
        } else if (isTablet) {
            deviceName = `Tablet_${mobileVendor}_${mobileModel}_${osName}${osVersion}_${browserName}${fullBrowserVersion}`
        }

        this.setState({ currentDeviceName: deviceName });
        this.getDivisionDetails();
    }
    onClickClear = () => {
        this.setState({            
            employeeNumber: ""
        });
    }
    getDivisionDetails() {
        let { divisionNumberDD } = this.state;
        let requestData = { SearchText: [] };
        let url = `${ApiUrls.Routes.DIVIS_C}${ApiUrls.Routes.GT_A_DVS_LT_M}`;
        Api.Post(url, requestData, this).then((responseData) => {
            try {
                if (responseData.success) {
                    if (responseData.data) {
                        responseData.data.length > 0 && responseData.data.map((a) => (
                            divisionNumberDD.push({ key: a.divisionId, value: a.divisionId, text: a.divisionName })
                        ));
                        this.setState({ divisionNumberDD }, () => {
                            this.getCurrentDeviceInfo();
                        });
                    }
                }
                else {
                    MessageBox(responseData.message, Constants.ERROR);
                }
            }
            catch (err) {
                MessageBox(err.message, Constants.ERROR);
            }
        });
    }

    handleDivisionChange = (e, { value, options }) => {
        let { selectedDivisionId } = this.state;
        selectedDivisionId = value;
        let selectedDivisionName = options.find(a => a.value === value)?.text;
        this.setState({
            selectedDivisionName: selectedDivisionName,
            selectedDivisionId
        });
    }

    getCurrentDeviceInfo() {
        try {
            if (this.state.deviceId > 0) {
                let { divisionNumberDD, fullName } = this.state;
                this.showLoader(true);
                let url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.GT_DEVCE_M}`;
                Api.Get(url, this, true, true).then((responseData) => {
                    try {
                        if (responseData.success) {
                            if (responseData.data) {
                                var deviceobj = responseData.data.find(a => a.deviceID === this.state.deviceId);
                                if (deviceobj) {
                                    var device = deviceobj.deviceEmpID.split('_');
                                    var selecteddivision = divisionNumberDD.find(a => a.text === device[0]);
                                    //remove first element
                                    device.shift();
                                    //remove last element
                                    device.pop();
                                    fullName = device.join('_');

                                    if (!selecteddivision) {
                                        MessageBox('Selected division is not available', Constants.ERROR);
                                    }
                                    else {
                                        this.setState({
                                            selectedDivisionName: selecteddivision.text,
                                            selectedDivisionId: deviceobj.divisionId,
                                            fullName
                                        });
                                    }
                                }
                            }
                            this.showLoader(false);
                        }
                        else {
                            MessageBox(responseData.message, Constants.ERROR);
                            this.showLoader(false);
                        }
                    }
                    catch (err) {
                        MessageBox(err.message, Constants.ERROR);
                    }
                });
            }
        }
        catch (err) {
            MessageBox(err.message, Constants.ERROR);
        }
    }

    getWebDevicesByEmployeeNumber() {
        if (!this.state.deviceId) {
            let { employeeNumber, employeeRegiterdDevices } = this.state;
            this.showLoader(true);//71506
            let url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.GT_REGDEVI_BY_EMPNUM_M}?employeeNumber=${employeeNumber}`;
            Api.Get(url, this).then((responseData) => {
                try {
                    if (responseData.success) {
                        employeeRegiterdDevices = responseData.data;
                    }
                    else {
                        employeeRegiterdDevices = [];
                        MessageBox(responseData.message, Constants.ERROR);
                    }
                    this.setState({ employeeRegiterdDevices: employeeRegiterdDevices, selectedEmployeeDevice: "" });
                    this.showLoader(false);
                }
                catch (err) {
                    MessageBox(err.message, Constants.ERROR);
                    this.showLoader(false);
                }
            });
        }

    }

    checkValidation() {
        let { fullName, selectedDivisionName } = this.state;
        if (!selectedDivisionName) {
            MessageBox('Choose the division number', Constants.ERROR);
            return false;
        }
        if (!fullName.trim()) {
            MessageBox('Enter full name', Constants.ERROR);
            return false;
        }
        return true;
    }

    showLoader = (visible) => {
        this.setState({ isShowLoader: visible });
    }

    onClickRegister = () => {
        let { fullName, selectedDivisionName, selectedDivisionId, deviceUUID, currentDeviceName, deviceType } = this.state;
        var isValid = this.checkValidation();
        if (isValid) {
            this.showLoader(true);
            fullName = fullName.trim();
            var requestData = {
                DeviceName: currentDeviceName,
                LastSync: '',
                Status: 'active',
                DeviceEmpID: `${selectedDivisionName}_${fullName}_${deviceType}`,
                AppVersion: packageJson.version,
                DeviceUUID: deviceUUID,
                DivisionId: selectedDivisionId,
                EmployeeName: fullName 
            }
            let url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.REGSTR_DEVICE_M}`;
            Api.Post(url, requestData, this).then(async (responseData) => {
                try {
                    if (responseData.success && responseData.data) {                        
                        window.localStorage.setItem('deviceUniqueGuid', deviceUUID);
                        MessageBox(responseData.message, Constants.SUCCESS);
                        this.props.history.push("/login");
                    }
                    else {
                        MessageBox(responseData.message, Constants.ERROR);
                    }
                }
                catch (err) {
                    MessageBox(responseData.message, Constants.ERROR);
                }
            });
        }
    }

    onClickSync() {
        try {
            let { fullName, deviceType, selectedDivisionId, selectedDivisionName, deviceUUID, currentDeviceName } = this.state;
            var isValid = this.checkValidation();
            if (isValid) {
                this.showLoader(true);
                fullName = fullName.trim();
                var saveData = {
                    DeviceName: currentDeviceName,
                    LastSync: '',
                    Status: 'active',
                    DeviceEmpID: `${selectedDivisionName}_${fullName}_${deviceType}`,
                    AppVersion: packageJson.version,
                    DeviceUUID: deviceUUID,
                    DeviceID: this.props.device.deviceId,
                    DivisionId: selectedDivisionId,
                    EmployeeName: fullName
                };
                if (saveData) {
                    let url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.UPD_DEVICE_M}`;
                    Api.Post(url, saveData, this).then(async (responseData) => {
                        MessageBox(responseData.message, Constants.SUCCESS);
                        if (responseData.success) {
                            window.localStorage.setItem('deviceUniqueGuid', deviceUUID);
                            this.props.history.push("/login");
                        }
                        else {
                            this.showLoader(false);
                            throw new Error(responseData.message);
                        }
                    });
                }
            }
        }
        catch (err) {
            MessageBox(err.message, Constants.ERROR);
        }
    }

    onTrimDeviceName = (e, { value }) => {
        let { fullName } = this.state;
        value = utility.deviceNameRegExp(value);
        this.setState({ fullName: value });
    }

    onClickBack() {
        this.props.history.push("/Login");
    }
    onUpdateWebDeviceFingerPrint() {
        try {
            let { selectedEmployeeDevice, deviceUUID, currentDeviceName } = this.state;
            if (selectedEmployeeDevice) {
                this.showLoader(true);
                var saveData = {
                    deviceId: selectedEmployeeDevice.deviceID,
                    fingerPrintId: deviceUUID,
                    deviceName: currentDeviceName
                };
                if (saveData) {
                    let url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.UT_WEBDFIP_M}`;
                    Api.Post(url, saveData, this).then(async (responseData) => {
                        MessageBox(responseData?.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
                        if (responseData.success) {
                            window.localStorage.setItem('deviceUniqueGuid', deviceUUID);
                            this.props.history.push("/login");
                        }
                        this.showLoader(false);
                    });
                }
            }
            else {
                MessageBox(Constants.PLEASE_SELECT_VALID_DEVICE_FROM_LIST, Constants.ERROR);
            }
        }
        catch (err) {
            MessageBox(err.message, Constants.ERROR);
        }
    }
    onSelectAlreadyRegistered() {
        this.setState({ isShowRegisteredDeviceModel: true, employeeRegiterdDevices: [], selectedEmployeeDevice: "", employeeNumber: "" });
    }
    onSelectRegisteredDevice(e, { value }) {
        this.setState({ selectedEmployeeDevice: value });
    }
    onEmployeeNumber(event) {
        this.setState({ employeeNumber: event.target.value });
    }
    onCloseDeviceSelectionModel() {
        this.setState({ isShowRegisteredDeviceModel: false });
    }
    render() {
        const { isDeviceAlreadyRegistered, employeeNumber, isShowRegisteredDeviceModel, employeeRegiterdDevices, selectedEmployeeDevice, selectedDivisionName, selectedDivisionId, fullName, deviceType, divisionNumberDD, deviceModelDD, isShowLoader } = this.state;
        return (
            <RegisterComponent
                {...{
                    register: {
                        selectedDivisionName,
                        selectedDivisionId,
                        fullName,
                        deviceType,
                        divisionNumberDD,
                        deviceModelDD,
                        isDeviceAlreadyRegistered,
                        isShowLoader,
                        employeeRegiterdDevices,
                        selectedEmployeeDevice,
                        isShowRegisteredDeviceModel,
                        employeeNumber
                    }
                }}
                handleDivisionChange={this.handleDivisionChange.bind(this)}
                onClickSync={this.onClickSync.bind(this)}
                onClickRegister={this.onClickRegister.bind(this)}
                onClickBack={this.onClickBack.bind(this)}
                onTrimDeviceName={this.onTrimDeviceName.bind(this)}
                onSelectAlreadyRegistered={this.onSelectAlreadyRegistered.bind(this)}
                onSelectRegisteredDevice={this.onSelectRegisteredDevice.bind(this)}
                onCloseDeviceSelectionModel={this.onCloseDeviceSelectionModel.bind(this)}
                getWebDevicesByEmployeeNumber={this.getWebDevicesByEmployeeNumber.bind(this)}
                onEmployeeNumber={this.onEmployeeNumber.bind(this)}
                onUpdateWebDeviceFingerPrint={this.onUpdateWebDeviceFingerPrint.bind(this)}
                onClickClear={this.onClickClear.bind(this)}
            />
        );
    };

}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user,
        device: state.deviceReducer.device
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            actions),
        dispatch);
}

Register.displayName = 'Register';

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Register));